var initialState = {
    education: {},
    conditions: {},
    activeBodyParts: "",
    bodyPart: {
        items: {},
        isFetching: false
    },
    symptom: {
        items: {},
        isFetching: false
    },
    toolbox: {
        isFetching: false,
        data: {}
    },
    disease: {
        isFetching: false,
        data: {},
        error: {}
    },
    selectedCondition: {
        items: {},
        isFetching: false,
        error: {}
    },
    activeIntervention: {},
    activeCondition: {},
    featuredPlacement: {},
    sponsoredPlacement: {},
    activeEducationToggle: "SYMPTOMS",
    auth: {
        isFetching: false,
        error: {},
        token: null,
        user: {},
        profile: {},
        loginRedirectUrl: ''
    },
    newsletter: {
        isFetching: false,
        error: {},
        items: {}
    },
    password: {
        isFetching: false,
        data: {},
        error: {}
    },
    message: {
        isFetching: false,
        error: {},
        messageData: {}
    },
    messages: {
        isFetching: false,
        data: {},
        error: {}
    },
    tags: {
        isFetching: false,
        data: {},
        error: {}
    },
    targets: {
        isFetching: false,
        data: {},
        error: {}
    },
    profile: {
        isFetching: false,
        data: {},
        error: {},
        success: '',
        postalCodeError: {}
    },
    common: {
        generic_error: '',
        generic_response_error: ''
    },
    showFacebookLikeModal: false,
    contact: {
        isFetching: false,
        data: {},
        error: {}
    },
    contentList: {
        isFetching: false,
        data: {},
        error: {}
    },
    surveys: {
        index: [],
        surveyType: null,
        isFetching: false,
        data: ["clinical_trials_opt_in_survey"],
        error: {},
        currentSurveyIndex: 0,
        currentSequenceIndex: 0,
        progress: 0
    },
    surveyStateHistory: {
        data: []
    },
    specialists: {
        isFetching: false,
        postalCode: '',
        data: [],
        error: {}
    },
    specialist: {
        isFetching: false,
        data: {},
        mySpecialist: {},
        mySpecialistPractice: {},
        specialistPendingAction: {
            actionFnName: '',
            actionFnParams: []
        },
        error: {}
    },
    post: {},
    postList: {
        categories: [
            {
                displayName: 'All',
                friendlyUrl: 'all'
            },
            {
                displayName: 'News & Updates',
                friendlyUrl: 'news-updates'
            },
            {
                displayName: 'Expert Opinions',
                friendlyUrl: 'expert-opinions'
            },
        ]
    },
    practice: {
        isFetching: false,
        data: {},
        error: {}
    },
    trials: {
        isFetching: false,
        totalCount: 0,
        data: [],
        error: {}
    },
}
module.exports = initialState;



// WEBPACK FOOTER //
// ./src/common/modules/initialState.js